import { render, staticRenderFns } from "./orderCenter.vue?vue&type=template&id=c55328bc&scoped=true&"
import script from "./orderCenter.vue?vue&type=script&lang=js&"
export * from "./orderCenter.vue?vue&type=script&lang=js&"
import style0 from "./orderCenter.vue?vue&type=style&index=0&id=c55328bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55328bc",
  null
  
)

export default component.exports